import React from "react";
import { FaGithub, FaLink, FaNodeJs } from "react-icons/fa";
import {
  ProjectDiv,
  Row,
  ServiceBox,
  ServiceBoxHeader,
  ServiceBoxP,
  A,
  BoxDiv,
} from "./Styles";
import { Container, Common, H1 } from "../../SharedStyles/SharedStyles";
import { AiFillGithub } from "react-icons/ai";
import { FaHtml5, FaReact, FaJs, FaCss3 } from "react-icons/fa";
import { SiMongodb, SiNodeDotJs, SiRedux, SiHeroku,SiExpress} from "react-icons/si";

import { v4 as uuidv4 } from "uuid";

const Projects = () => {
  const projects = [
    {
      id: 1,
      project_name: "Bewakoof Clone",
      image:
        "https://camo.githubusercontent.com/786d09b7daa669f9e26aa4aa8c8f633339113340da015616214fb15385f4f61f/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313030302f312a556a3567544e77304d4e3853423974693379706145512e706e67",
      project_desc:
        "	 A web application to sell and buy clothing material ",
      deploy_link:
        "https://nitish8800.github.io/BewaKoof_Clone/",
      repo_link: "https://github.com/itarun1/bewakoof_clone",
      tech_stack: [<FaHtml5 />, <FaCss3 />, <FaJs />],
    },
    {
      id: 2,
      project_name: "Dineout clone",
      image:
        "https://camo.githubusercontent.com/25153994bdbe90b0866600042cfe59ce358f20afaf0a87a4687b85fcce76b4cf/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f3836382f312a765444764763346a784b506c326173376b456c5167512e706e67",
      project_desc:
        "Dineout is a website for users to explore restaurants around a particular city and see the reviews, book table, see new offers in the restaurants.",
      deploy_link: "https://dineout-sandy.vercel.app/",
      repo_link: "https://github.com/itarun1/Dineout_clone",
      tech_stack: [<FaHtml5 />, <FaCss3 />, <FaJs />, <FaNodeJs />, <SiMongodb />, <SiExpress />,],
    },
    {
      id: 3,
      project_name: "Clone of YesStyle",
      image:
        "https://miro.medium.com/max/875/1*54tc54lVhhApYqCbJH7qTg.png",
      project_desc:
        "This is a clone of a Japnise-based e-commerce website for fashion accessories products. Which sells clothes and accessories.",
        deploy_link: "https://yesstyle-web-app.herokuapp.com/",
      repo_link: "https://github.com/RoshanIndane/Unit4_YesstyleClone",
      tech_stack: [
        // <SiRedux />,
        // <SiMaterialui />,
        <SiMongodb />,
        <SiExpress />,
        // <AiFillGithub />,
        <FaNodeJs />,
        <FaHtml5 />,
        <FaCss3 />,
        <FaJs />,
      ],
    },
    {
      id: 4,
      project_name: "Monster India Clone",
      image:
        "https://user-images.githubusercontent.com/45921293/161429933-174ad69e-5135-4cf5-b1e8-fbbdad0ec0df.PNG",
      project_desc:
        "This project is a complete clone UI of the MonsterIndia website with the functionalities of Searchin Jobs. We used Database using Mongo Atlas to save user data, geting the product in product page. cart page and wish list page.",
      deploy_link: "monster-india-clone.vercel.app/",
      repo_link: "https://github.com/itarun1/Monster-India-clone",
      tech_stack: [
        <FaNodeJs />,
        <SiMongodb />,
        <FaJs />,
        <SiHeroku />,
        <FaHtml5 />,
        <FaCss3 />,
        <SiMongodb />,
        <SiExpress />,
          <SiRedux />,
      ],
    },
    // {
    //     id: 5,
    //     project_name: 'Weather And Google',
    //     image: 'https://github.com/Mukesh16407/git_2nd/blob/master/weatherandGoogle_api.png?raw=true',
    //     project_desc:
    //         'A simple App which is used for Seven Day forcasting  weather and location.Also add tempterature and  wind Speed.',
    //     deploy_link: 'https://my-weathermap.netlify.app/',
    //     repo_link: 'https://github.com/Mukesh16407/weaterandGoolemap',
    //     tech_stack: [ <FaJs />, <FaHtml5 />, <FaCss3 />],
    // },
    {
      id: 6,
      project_name: "Language Translator",
      image:
      'https://camo.githubusercontent.com/a8d7a76b9e61b99bf26bc26e9821cf7afcd4f80e400d3fdd91166d5f0fa8581b/68747470733a2f2f692e6962622e636f2f783272356830522f53637265656e73686f742d3231322e706e67',
      project_desc:
 'This basically works like a translator works like google translate.',
      deploy_link: "https://js-translator-main.vercel.app/",
      repo_link: "https://github.com/itarun1/LanguageTranslator",
      tech_stack: [<FaJs />, <FaHtml5 />, <FaCss3 />],
    },
  ];

  return (
    <Container className="projects">
      <ProjectDiv>
        <Common>
          <H1>Projects</H1>
        </Common>
        <Row>
          {projects.map((item) => (
            <BoxDiv key={uuidv4()}>
              <ServiceBox>
                <img src={item.image} alt="icon" style={{ width: "100%" }} />
                <div style={{ margin: "25px" }}>
                  <ServiceBoxHeader style={{ textAlign: "center" }}>
                    {item.project_name}
                  </ServiceBoxHeader>
                  <ServiceBoxP>{item.project_desc}</ServiceBoxP>
                  {/* <strong>Features</strong>
                  <ServiceBoxP>{item.features}</ServiceBoxP> */}
                  {/* <a href="">Read more</a> */}
                  <div
                    style={{
                      margin: "20px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {item.tech_stack.map((item) => (
                      <div key={uuidv4()} className="iconsTechStack">
                        {item}
                      </div>
                    ))}
                  </div>
                  <A
                    href={item.repo_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGithub /> Code
                  </A>
                  <A
                    href={item.deploy_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLink /> Demo
                  </A>
                </div>
              </ServiceBox>
            </BoxDiv>
          ))}
        </Row>
      </ProjectDiv>
    </Container>
  );
};

export default Projects;
